import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import CustomHeading from "./custom/CustomHeading";
import CustomContent from "./custom/CustomContent";
import CustomParagraphComponent from "./Facilities/CustomParagraphComponent";
import GetInTouchFooter from "./GetInTouchFooter";
import Loader from "./custom/Loader";
import { toast } from "react-toastify";
import axiosStrapiInstance, { baseUrl } from "../axiosStrapi";
import { headerImages } from "../utils/constants";
import { Helmet } from "react-helmet";

const Facilities = () => {
  const [facilities, setFacilities] = useState([]);
  const [loading, setLoading] = useState(false);
  async function getFacilities(e) {
    try {
      setLoading(true);
      const response = await axiosStrapiInstance.get(
        "/api/page-contents?filters[pageType][$eq]=Facilities&populate=*&sort=pageTypeId:asc"
      );
      const result = response?.data?.data?.map((item) => ({
        ...item,
        images: item?.images?.map((item) => `${item?.url}`),
      }));
      setFacilities(result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
    }
  }

  useEffect(() => {
    getFacilities();
    const timer = setTimeout(() => {
      window.scrollTo(0, 1);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div>
      <Helmet>
        <title>
          Preschool Facilities at Mother's Pride - Safe & Stimulating
          Environment
        </title>
        <meta
          name="description"
          content="Discover the state-of-the-art facilities at Mother's Pride Preschool designed to offer a safe, nurturing, and stimulating environment for young learners."
        />
        <meta
          name="keywords"
          content="school celebrations, preschool festivals, cultural events, festive learning, celebration at school"
        />
        <link
          rel="canonical"
          href="https://www.motherspridepreschool.com/facilities"/>
      </Helmet>
      <div>
        <div>
          <img
            src={
              window.innerWidth < 450
                ? window.innerWidth < 800
                  ? headerImages.tabFacilitiesHeaderImg
                  : headerImages.mobileFacilitiesHeaderImg
                : headerImages.facilitiesHeaderImg
            }
            alt="facilities"
            className="overflow-x-hidden w-[100vw] sm:h-[300px] lg:h-[420px]"
          />
        </div>
        <div className="px-[4%] 2xl:px-[6%] flex flex-col gap-10 ">
          {/* main img */}

          <div className="flex flex-col gap-3 mt-5 sm:mt-[60px]">
            <div className="flex w-full flex-row items-end lg:mt-0 mt-5 gap-1">
              <CustomHeading
                text={"Facilities at mother"}
                spanText={"'"}
                spanTextColor="#383838"
                thirdTextColor="#383838"
                secondFontStyle="font-Lato"
                thirdText={"s Pride"}
                textSize="58px"
                heartPosition="absolute"
                textColor="#383838"
                showHeart={window.innerWidth < 450 ? false : true}
                heartMarginLeft={window.innerWidth < 450 ? "2%" : "50%"}
                heartHeight="40px"
                heartWidth="40px"
                smTextSize="32px"
              />
              <div className="inline">
                <CustomContent
                  textColor="#d31c4f"
                  text={"//PreSchool"}
                  textSize="42px"
                  smTextSize="20px"
                  leading="52px"
                  marginTop={window.innerWidth < 450 ? "-32px" : "0"}
                />
              </div>
            </div>
            <CustomContent
              textColor="#111010"
              text={
                "At Mother’s Pride, we boast a state-of-the-art child-friendly infrastructure that our little Prideens enjoy. With colourful premises, we ensure that we create a fun and inviting atmosphere for our children. Our premises are designed with colourful castles for the kids to enjoy and a ball pool plus a splash pool to cool off in the summers!"
              }
              textSize="24px"
              leading="38px"
              textAlign="justify"
              smTextSize="18px"
            />
          </div>

          {/* facilities */}
          <div className="flex flex-col gap-[50px] ">
            {loading ? (
              <Loader />
            ) : (
              facilities?.map((item, index) => (
                <CustomParagraphComponent
                  key={index}
                  heading={item?.heading}
                  content={item?.content}
                  images={item?.images}
                />
              ))
            )}
          </div>

          <GetInTouchFooter marginX={"0%"} />
          {/* Footer */}
          <div>
            <Footer marginX={"0%"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Facilities;
